import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./Crm.css";
import Ticket from "./CrmTicket";
import TicketCard from "./Components/CrmCarousalTicket";
import { FieldListService } from "../../../service/manage/crm/crm_field_list.service";

const CustomCarousel = ({ items, deviceType, state }) => {
  const [users, setUsers] = useState([]);
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [sortDirection, setSortDirection] = useState("asc");  
  const [sortColumn, setSortColumn] = useState("user_code");
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [selectedSearchFilter, setSelectedSearchFilter] = useState({});

  useEffect(() => {
    fetchAllUsers();
  }, [state]);

  const fetchAllUsers = async () => {
    setIsUserLoading(true);
    try {
      const response = await FieldListService.getAllCrmUsers(
        state?.mid,
        state?.form_list_id,
        state?.lg_user_id,
        state?.lg_user_table_id,
        5000,
        0,
        sortColumn,
        sortDirection,
        userSearchTerm
      );
      setUsers(response?.data?.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsUserLoading(false);
    }
  };

  const parseOwners = (f24Value) => {
    if (!f24Value || !Array.isArray(f24Value)) return [];
    
    const ownerNames = [];
    
    f24Value.forEach(tupleString => {
      if (typeof tupleString !== 'string' || !tupleString.startsWith('(')) return;
    
      const tupleValues = tupleString.replace(/[()]/g, '').split(',');
      
      if (tupleValues.length < 3) return;
      
      const userId = parseInt(tupleValues[1]);
      const userTableId = parseInt(tupleValues[2]);
      
      // Find matching user in the users array
      const matchedUser = users.find(user => 
        user.user_id === userId && user.user_table_id === userTableId
      );
      
      if (matchedUser && matchedUser.data_concat) {
        ownerNames.push(matchedUser.data_concat);
      }
    });
    
    return ownerNames;
  };


  const parseCreator = (f30Value) => {
    if (!f30Value) return '';
    
    try {
      if (typeof f30Value === 'object') {
        const tupleString = Object.keys(f30Value)[0];
        return extractCreatorFromTuple(tupleString);
      }
      
      if (typeof f30Value === 'string') {
        if (f30Value.startsWith('(')) {
          return extractCreatorFromTuple(f30Value);
        }
      
        try {
          const parsed = JSON.parse(f30Value);
          const tupleString = Object.keys(parsed)[0];
          return extractCreatorFromTuple(tupleString);
        } catch (e) {
          const match = f30Value.match(/\((\d+),(\d+)\)/);
          if (match) {
            const userId = parseInt(match[1]);
            const userTableId = parseInt(match[2]);
            return findCreatorName(userId, userTableId);
          }
        }
      }
      
      return '';
    } catch (error) {
      console.error("Error parsing creator:", error);
      return '';
    }
  };
  
  const extractCreatorFromTuple = (tupleString) => {
    if (!tupleString || !tupleString.startsWith('(')) return '';
    
    const tupleValues = tupleString.replace(/[()]/g, '').split(',');
    if (tupleValues.length < 2) return '';
    
    const userId = parseInt(tupleValues[0]);
    const userTableId = parseInt(tupleValues[1]);
    
    return findCreatorName(userId, userTableId);
  };
  
  const findCreatorName = (userId, userTableId) => {
    const matchedUser = users.find(user => 
      user.user_id === userId && user.user_table_id === userTableId
    );
    return matchedUser?.data_concat || '';
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <Carousel
      swipeable={true}
      draggable={true}
      showDots={true}
      responsive={responsive}
      ssr={true}
      infinite={true}
      keyBoardControl={true}
      containerClass="carousel-container"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      deviceType={deviceType}
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-40-px"
    >
      {items.map((ticket, index) => {
        const owners = parseOwners(ticket?.f24);
        
        return (
          <div key={index}>
            <TicketCard
              blockTitle={ticket?.f16}
              trailTitle={ticket?.f12}
              longText={ticket?.f20}
              reminders={ticket?.f21}
              eta={ticket?.f22}
              tags={ticket?.f23}
              owners={owners}
              taskStatus={ticket?.f25}
              createdAt={ticket?.f26}
              doneAt={ticket?.f27}
              updatedAt={ticket?.f28}
              blockStatus={ticket?.f29}
              creator={parseCreator(ticket?.f30)}
              isOwnersLoading={isUserLoading}
            />
          </div>
        );
      })}
    </Carousel>
  );
};

export default CustomCarousel;